import React, { useState } from 'react';
import { TableHeader, TableBody } from '../components/TableStyles';
import { filterTableRows, generatePageNumbers } from '../utils/tableHelpers';

export const useTable = ({ children, paginate, searchable }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');

  let headerNode = null;
  let bodyNode = null;
  let otherNodes = [];

  React.Children.forEach(children, (child) => {
    if (React.isValidElement(child)) {
      if (child.type === TableHeader) {
        headerNode = child;
      } else if (child.type === TableBody) {
        bodyNode = child;
      } else {
        otherNodes.push(child);
      }
    } else {
      otherNodes.push(child);
    }
  });

  let paginatedBodyNode = bodyNode;
  let totalPages = 1;

  if (bodyNode) {
    let rows = React.Children.toArray(bodyNode.props.children);
    rows = rows.filter(Boolean);

    if (searchable && searchTerm) {
      rows = filterTableRows(rows, searchTerm);
    }

    if (paginate) {
      const totalItems = rows.length;
      totalPages = Math.ceil(totalItems / itemsPerPage) || 1;

      const safePage = Math.min(Math.max(1, currentPage), totalPages);
      const startIndex = (safePage - 1) * itemsPerPage;
      const slicedRows = rows.slice(startIndex, startIndex + itemsPerPage);

      paginatedBodyNode = React.cloneElement(bodyNode, {}, slicedRows);
    } else {
      paginatedBodyNode = React.cloneElement(bodyNode, {}, rows);
    }
  }

  const safeCurrentPage = Math.min(Math.max(1, currentPage), totalPages);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const pageNumbers = generatePageNumbers(safeCurrentPage, totalPages);

  return {
    headerNode,
    paginatedBodyNode,
    otherNodes,
    currentPage: safeCurrentPage,
    totalPages,
    itemsPerPage,
    searchTerm,
    pageNumbers,
    handlePageChange,
    handleSearchChange,
    handleItemsPerPageChange,
  };
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Table/hooks/useTable.js